import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import "./assets/css/index.scss";
import store from './store'
import LoginDialog from './components/LoginDialog.vue';
import vueclipboard2 from 'vue-clipboard2'
// 富文本组件
import Editor from "@/components/Editor"
import ImageUpload from "@/components/ImageUpload"
import plugins from './plugins'
Vue.config.productionTip = false
// 全局注册登录组件
Vue.component('login-dialog', LoginDialog);
Vue.component('editor-txt', Editor)
Vue.component('ImageUpload', ImageUpload)



import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

import "@/plugins/log.js"; 
import "@/plugins/message.js"; 
import _mixin from "@/mixins/index.js";
Vue.mixin(_mixin);





Vue.use(ElementUI)
Vue.use(vueclipboard2)
Vue.use(plugins)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
